// Import CSS for Vite. Path is relative to this JS file
import '@css/app.css'

//
import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import persist from '@alpinejs/persist';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import morph from '@alpinejs/morph';
import ui from '@alpinejs/ui';
import masonry from 'alpinejs-masonry';
import splide from '@splidejs/splide';
import Player from '@vimeo/player';
import 'lite-youtube-embed';
import 'lite-vimeo-embed';
//import { gsap } from "gsap";
//import { ScrollTrigger } from "gsap/ScrollTrigger";
//gsap.registerPlugin(ScrollTrigger);

window.splide = splide;
window.Alpine = Alpine;
window.Player = Player;
Alpine.plugin(ui);
Alpine.plugin(intersect);
Alpine.plugin(persist);
Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(morph);
Alpine.plugin(masonry);



/*let boxes = gsap.utils.toArray(".box");

gsap.to(boxes,{
	x: () => window.innerWidth - (boxes[0].offsetWidth * boxes.length),
	ease: "none",
	scrollTrigger:{
	trigger: "#colorBox",
	start: "middle top",
	pin: true,
	scrub: 1 ,
	invalidateOnRefresh: true,
	// snap:1  / (boxes.length - 1),
	end: () => "+=" + document.querySelector("#colorBox").offsetWidth,
	}
});*/

/*gsap.to(boxes,{
	xPercent: 0,
	yPercent: 25,
	x: 0,
	y: 0,
	ease: "none",
	scrollTrigger: {
		trigger: "#colorBox",
		start: "middle top",
	}
});*/

/*
let header = document.querySelector(".js-header");
// construct an instance of Headroom, passing the element
if(header){
	var headroomHeader  = new Headroom(header, {
		offset : 82,
		tolerance : {
			up : 20,
			down : 0
		},
	});
	// initialise
	headroomHeader.init();
}
*/

/*window.App = Object.assign(window.App !== undefined ? window.App : {}, {
	marquee: marquee
});*/

/*function video() {
	const iframe = document.querySelector('iframe');
	const player = new Vimeo.Player(iframe);
	return {
		open:false,
		title: '',
		client: '',
		director: '',
		credits: [],
		loadVideo(id){
			player.pause().then(
				player.loadVideo(id).then(v => {
					player.play()
				} )
			)
		},
		play(){
			player.play()
		},
		stop(){
			player.pause()
		},
		init(){
		},
	};
}*/


// .no-js to .js
let html = document.getElementsByTagName("html")[0];
html.className = html.className.replace("no-js", "js");

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html & https://nystudio107.com/docs/vite/
 */
if (import.meta.hot) {
	import.meta.hot.accept(() => {
		console.log('HMR')
	})
}

Alpine.start();